import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Label, Input, Row, Table, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import { createDeepClone } from "../utils/index";

import CardLoader from "./CardLoader";
import MyDateRenderer from "./MyDateRenderer";
import ConfirmModal from "./ConfirmModal";

import { useDispatch, useSelector } from "react-redux";
import * as isoRequestActions from "../actions/IsoRequestActions";

const IsoRequestGrid = (props) => {
    const dispatch = useDispatch();

    const loading = useSelector((state) => state.iso.loadingItems);
    const itemList = useSelector((state) => state.iso.itemList);
    
    const [fboState, setFBOState] = React.useState(itemList);
        
    React.useEffect(() => {
		dispatch(isoRequestActions.loadIsoRequestItems(props.refId));
    }, [props.serviceId, props.refId]);

    React.useEffect(() => {
		setFBOState(itemList);
    }, [itemList]);

    return (
        <Fragment>
            <Card className="mb-0">
                <CardHeader className="border-0 d-flex align-items-center">
                    <CardLoader loading={loading} />
                    <h5 className="card-title mb-0 flex-grow-1">Container ISO Tickets</h5>
                </CardHeader>
                <CardBody className="border border-dashed border-end-0 border-start-0">
                    <Row className="gy-2">
                        <Col xxl={12} md={12}>
                            <Table className="table-hover table-bordered align-middle mb-0">
                                <thead className="table-primary">
                                    <tr>
                                        <th>Ticket #</th>
                                        <th>Request Type</th>
                                        <th>Status</th>
                                        <th>Document Controller</th>
                                        <th>Technical Reviewer</th>
                                        <th>Decision Maker</th>
                                        <th>Last Action</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {fboState.length == 0 && <tr><td colSpan={7}>No Ticket(s) Added</td></tr>}
                                    {fboState.map(function(item, index){
                                        return(
                                            <tr key={index}>
                                                <td>{item.requestNumber}</td>
                                                <td>{item.requestType}</td>
                                                <td><span className="badge" style={{backgroundColor: item.statusColorCode}}>{item.statusName}</span></td>
                                                <td>{item.documentUserName}</td>
                                                <td>{item.technicalUserName}</td>
                                                <td>{item.decisionUserName}</td>
                                                <td><MyDateRenderer value={item.lastActionDate} /></td>
                                                <td className="text-center">
                                                    <UncontrolledDropdown className="dropdown d-inline-block">
                                                        <DropdownToggle className="btn btn-primary btn-sm" tag="button">
                                                            <i className="ri-more-fill align-middle"></i>
                                                        </DropdownToggle>
                                                        <DropdownMenu className="dropdown-menu-end">
                                                            <DropdownItem>
                                                                <Link to={`/iso-request-edit/${item.id}`}>
                                                                    <i className="ri-eye-line align-bottom me-2" /> View ISO Ticket
                                                                </Link>
                                                            </DropdownItem>
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown> 
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default IsoRequestGrid;